import { render } from "./cloud-platform.vue?vue&type=template&id=cad05e38&scoped=true"
import script from "./cloud-platform.vue?vue&type=script&lang=js"
export * from "./cloud-platform.vue?vue&type=script&lang=js"

import "./cloud-platform.vue?vue&type=style&index=0&id=cad05e38&lang=scss&scoped=true"

import exportComponent from "/Users/baikaifa/Desktop/ubang-deploy-work/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.42_vue@3.5.42_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cad05e38"]])

export default __exports__